import { render, staticRenderFns } from "./DeleteCategoryModal.vue?vue&type=template&id=4dea0975&"
import script from "./DeleteCategoryModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCategoryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports